import type { SchemaField } from '@cli-types/core-engine/schema.js'
import {
  ADD_FIELD_CONFIRM_INITIAL_VALUE,
  CREATE_PROMPT_CONTEXT
} from '@cli-constants/prompt-copy.js'
import { promptConfirm } from '../schema-prompts/prompt-confirm.js'
import { promptField } from '../schema-prompts/prompt-field.js'
import { createFieldPromptOptions } from './create-field-prompt-options.js'

export async function promptAdditionalSchemaFields(
  kind: 'entity' | 'single',
  schemasDir: string,
  fields: SchemaField[]
): Promise<void> {
  while (
    await promptConfirm(
      CREATE_PROMPT_CONTEXT,
      'Add another field?',
      ADD_FIELD_CONFIRM_INITIAL_VALUE
    )
  ) {
    fields.push(
      (await promptField(
        CREATE_PROMPT_CONTEXT,
        kind,
        schemasDir,
        'schema',
        0,
        createFieldPromptOptions(fields)
      )) as SchemaField
    )
  }
}
